import React from 'react';

interface Props {
	open: boolean;
	version: string | null;
	changelogUrl: string | null;
	onAcknowledge: () => void;
}

export const ReleaseNotesDialog: React.FC<Props> = ({ open, version, changelogUrl, onAcknowledge }) => {
	if (!open) return null;
	return (
		<div role="dialog" aria-modal="true" aria-labelledby="release-title" style={{
			position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300
		}}>
			<div style={{ background: 'white', color: '#111', width: 'min(720px, 90vw)', maxHeight: '80vh', borderRadius: 8, boxShadow: '0 10px 30px rgba(0,0,0,0.2)', display: 'flex', flexDirection: 'column' }}>
				<div style={{ padding: '16px 20px', borderBottom: '1px solid #eee' }}>
					<h2 id="release-title" style={{ margin: 0 }}>What’s new{version ? ` — v${version}` : ''}</h2>
				</div>
				<div style={{ padding: 20, overflow: 'auto' }}>
					{changelogUrl ? (
						<iframe title="Release notes" src={changelogUrl} style={{ width: '100%', height: '50vh', border: 0 }} />
					) : (
						<p>New updates have been released.</p>
					)}
				</div>
				<div style={{ padding: 16, borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
					{changelogUrl && (
						<a href={changelogUrl} target="_blank" rel="noreferrer" style={{ alignSelf: 'center' }}>Open changelog in new tab</a>
					)}
					<button onClick={onAcknowledge} style={{ background: '#111', color: 'white', border: 0, padding: '8px 14px', borderRadius: 6, cursor: 'pointer' }}>
						Got it
					</button>
				</div>
			</div>
		</div>
	);
}; 